import { render, staticRenderFns } from "./page_terminal_exception.vue?vue&type=template&id=3821c504&scoped=true&"
import script from "./page_terminal_exception.vue?vue&type=script&lang=js&"
export * from "./page_terminal_exception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821c504",
  null
  
)

export default component.exports